/* eslint-disable @typescript-eslint/no-magic-numbers */
import { useEffect } from 'react';

import useGetServerTime from '@/hooks/useGetServerTime';
import useStore from '@/store';

const useServerTime = () => {
  const { data, isFetched } = useGetServerTime();
  const { setServerTime } = useStore();

  useEffect(() => {
    if (isFetched && data?.serverTime) {
      setServerTime(data.serverTime);
    }
  }, [isFetched, data, setServerTime]);
};

export default useServerTime;
